import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';

import Submitter from '../react/Apps/Submitter';
// import { AuthContextProvider } from '../react/app_submitter/store/auth-context';
import formsReducer from '../react/components/UI/Form/store/forms-reducer';
import counterReducer from '../react/app_submitter/store/counter';
import qrcodeReducer from '../react/app_submitter/store/qr-code';
import qrImageReducer from '../react/app_submitter/store/qr-image';

import './react_apps.css';

const store = configureStore({
  reducer: { 
             counter: counterReducer,
             forms: formsReducer,
             qrcode: qrcodeReducer,
             img: qrImageReducer
           }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
const railsData = JSON.parse(document.getElementById('railsdata').getAttribute('data'));

root.render(
  <BrowserRouter>
    <Provider store={store} >
      <Submitter rails={railsData}/>
    </Provider>
  </BrowserRouter>
);

// <AuthContextProvider>
// </AuthContextProvider>